import React from 'react';

import PropTypes, { any } from 'prop-types';

import styles from './eventRegForm.scss';

const CampRegistrationSuccessCard = ({ division, currentRegistration }) => {
    return (
        <div className={styles.campDivisionSelection}>
            <div className="radio-button radio-button-xl">
                <input id={`division${division.id}`} type="checkbox" />
                <div className={styles.highlight}>
                    <label htmlFor={`division${division.id}`}>
                        <div className="radio-button-label">
                            <div className="d-flex justify-content-between">
                                <div className="flex-1 mw0 text-break mr8">
                                    <div>{division.name}</div>
                                    <div className="radio-button-description fs12 text-bold">{division?.divisionCategoryModel?.label}</div>
                                    <ul className="pl16">
                                        {currentRegistration.playerNames.map(player => (<li key={player}>{player}</li>))}
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </label>
                </div>
            </div>
        </div>
    );
};

CampRegistrationSuccessCard.propTypes = {
    division: PropTypes.objectOf(any).isRequired,
    currentRegistration: PropTypes.shape({
        price: PropTypes.number.isRequired,
        playerNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    }).isRequired,
};

CampRegistrationSuccessCard.defaultProps = {
};

export default CampRegistrationSuccessCard;
